import Header from "../components/desktop/Header";
import { Outlet } from "react-router-dom";
import "./ProfileLayout.css";

export default function ProfileLayout() {
  return (
    <div className="desktop-profile-layout">
      <Header />
      <main className="desktop-profile-main">
        <Outlet />
      </main>
    </div>
  );
}
